import "./Loader.css";

const Loader = (payload) => {
  return (
    <div className="loader">
      {payload.desc ? <span>{payload.desc}</span> : <span>Loading...</span>}

      {payload.isEmpty === true ? (
        ""
      ) : (
        <div className="loader-dots">
          <h1 className="dot-one">&middot;</h1>
          <h1 className="dot-two">&middot;</h1>
          <h1 className="dot-three">&middot;</h1>
        </div>
      )}
    </div>
  );
};

export default Loader;
